import { render, staticRenderFns } from "./HistoricoPedidos.vue?vue&type=template&id=2ae6d1f2&scoped=true"
import script from "./HistoricoPedidos.vue?vue&type=script&lang=js"
export * from "./HistoricoPedidos.vue?vue&type=script&lang=js"
import style0 from "./HistoricoPedidos.vue?vue&type=style&index=0&id=2ae6d1f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6d1f2",
  null
  
)

export default component.exports